<script setup lang="ts">
/**
 * DenialView — presentational only. The shared edit that wires this into
 * `guards.ts:181-194` is wave 4 (Atlas_Architecture.md §3.5 "One edit, three
 * deploys", N-8a) and is explicitly out of scope for this step (5.0 — build
 * only, adopt nothing). This component just renders an `AtlasDenialInfo`:
 * why + who grants + the original URL a role bounce would otherwise drop
 * (RULED M9 A).
 */
import type { AtlasDenialInfo } from '../../../types/atlas-contracts'

// `denial` is required by type; at runtime a guard that forgot to build one
// must render nothing rather than a view claiming a denial with no reason
// (wave-3 V2 L-6: the one negative a presentational component owns).
defineProps<{
  denial: AtlasDenialInfo | null | undefined
}>()
</script>

<template>
  <div
    v-if="denial"
    class="atlas-denial-view flex flex-col items-center gap-2 py-10 text-center"
    data-testid="atlas-denial-view"
  >
    <i class="pi pi-lock text-3xl text-surface-400" aria-hidden="true" />
    <p class="text-sm text-surface-600" data-testid="atlas-denial-reason">{{ denial.reason }}</p>
    <p class="text-xs text-surface-500" data-testid="atlas-denial-granted-by">Ask {{ denial.grantedBy }} for access.</p>
    <p class="text-xs text-surface-400 break-all" data-testid="atlas-denial-original-url">{{ denial.originalUrl }}</p>
  </div>
</template>
